import classes from "./EmptyGifLIst.module.scss";
import { Link } from "react-router-dom";
import { routes } from "routes";
import React from "react";

export const EmptyGifLIst = () => {
  return (
    <div className={classes.emptyGifList}>
      <strong>Nothing to see here</strong><br/>
      On this page you can edit or delete content that you upload.<br/>
      You have no uploaded content currently.<br/>
      Please <Link to={routes.create()}>upload</Link> some then come back.
    </div>
  );
};
